import React from 'react';

import { DocRequestStatus } from 'types/DocRequest';
import { Badge } from 'react-bootstrap';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface DocStatusBadgeProps {
  status?: DocRequestStatus,
  showLabel?: boolean
}

function DocStatusBadge( { status, showLabel = true }: DocStatusBadgeProps ) {
  let color = '';
  const icon = <IoMdInformationCircleOutline />;
  const { t } = useTranslation();

  switch ( status ) {
    case DocRequestStatus.pending:
      color = 'primary';
      break;
    case DocRequestStatus.inReview:
      color = 'warning';
      break;
    case DocRequestStatus.returned:
      color = 'danger';
      break;
    case DocRequestStatus.approved:
      color = 'success';
      break;
    default:
      color = 'light';
      break;
  }

  return (
    <Badge
      bg={color}
      className={classNames( 'd-flex align-items-center gap-1', {
        'badge-sm': !showLabel,
      } )}
    >
      {icon}
      {showLabel ? t( `admin.docs.status.${status}` ) : null}
    </Badge>
  );
}

export default DocStatusBadge;
